import { useQuery } from '@apollo/client';
import { gql } from '__generated__';
import { FC } from 'react';

import SidebarLayout from 'layouts/SidebarLayout';

import Banner from 'components/Banner';
import DetailsPanel from 'components/DetailsPanel';
import ErrorMessage from 'components/ErrorMessage';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';

const DASHBOARD_QUERY = gql(`
  query DashboardQuery {
    dashboard {
      id
      user {
        id
        fullName
      }
      statistics {
        totalDepartments
        totalEmployees
        totalIdentityCards
        numberOfIdentityCardsPrinted
      }
    }
  }
`);

const Dashboard: FC = () => {
  const { loading, error, data, refetch } = useQuery(DASHBOARD_QUERY);

  const renderContent = () => {
    if (loading) return <LoadingIndicator />;

    if (error || !data) return <ErrorMessage error={error} refetch={refetch} />;

    const dashboard = data.dashboard;

    return (
      <>
        <Banner
          title={`Welcome back, ${dashboard.user.fullName}`}
          description="This dashboard allows you to create and manage departments, employees, and identity cards."
          listItems={[]}
        />
        <DetailsPanel
          data={[
            {
              label: 'Total Departments',
              value: dashboard.statistics.totalDepartments,
              type: 'NUMBER',
            },
            {
              label: 'Total Employees',
              value: dashboard.statistics.totalEmployees,
              type: 'NUMBER',
            },
            {
              label: 'Total Identity Cards',
              value: dashboard.statistics.totalIdentityCards,
              type: 'NUMBER',
            },
            {
              label: 'Number of Identity Cards Printed',
              value: dashboard.statistics.numberOfIdentityCardsPrinted,
              type: 'NUMBER',
            },
          ]}
        />
      </>
    );
  };

  return (
    <SidebarLayout>
      <Navbar title="Dashboard" subTitle="Quick overview of things that need your attention" />
      {renderContent()}
    </SidebarLayout>
  );
};

export default Dashboard;
